module.exports = __webpack_public_path__ + "./img/download-metamask.215f4999d3915f4c6fb8139b12058f38.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/download-metamask.png
// module id = ./public/img/download-metamask.png
// module chunks = 0